import { Component, Input } from "@angular/core";

@Component ({
    selector: "magic-set-icon",
    imports: [],
    templateUrl: "./magic-set-icon.component.html"
})
export class MagicSetIconComponent {
    @Input({ required: true}) public setCode!: string;
    @Input({ required: false }) public rarity?: string;
    @Input({ required: false }) public filterClass?: string;
    @Input({ required: false }) public small: boolean = false;

    public iconUrl!: string;

    public ngOnInit(): void {
        this.filterClass = this.filterClass ?? `filter-magic-${this.rarity?.toLowerCase() ?? "common"}`;
        this.iconUrl = this.getIconUrl();
    }
    
    private getIconUrl(): string {
        var setCode = this.setCode;

        if (setCode.startsWith("sld")) {
            // Handle the SLD drop subsets
            setCode = "sld";
        }

        return `https://images.pondertcg.com/magic/set/${setCode}.svg`;
    }
}